// Environment variables in this file are only available on the server side. They are not available on the client side.
// If you want to use them on the client side, see `client.ts` and the `useClientEnvironment` hook.

// Environment service
export const ENV_HOST = process.env.ENV_HOST || "localhost";
export const ENV_PORT = process.env.ENV_PORT || "8120";
export const ENV_API_ORIGIN = `http://${ENV_HOST}:${ENV_PORT}`;

// Environment service handshake
export const HANDSHAKE_ENV = process.env.HANDSHAKE_ENV || "";
export const HANDSHAKE_INTERNAL = process.env.HANDSHAKE_INTERNAL || "";

// Reviews service
export const REVIEWS_HOST = process.env.REVIEWS_HOST || "localhost";
export const REVIEWS_PORT = process.env.REVIEWS_PORT || "8122";
export const REVIEWS_API_ORIGIN = `http://${REVIEWS_HOST}:${REVIEWS_PORT}`;

// Spaces service v2
export const SPACES_V2_HOST = process.env.SPACES_V2_HOST || "localhost";
export const SPACES_V2_PORT = process.env.SPACES_V2_PORT || "8188";
export const SPACES_V2_API_ORIGIN = `http://${SPACES_V2_HOST}:${SPACES_V2_PORT}`;

// Listings service (legacy)
// Used by the profile page to fetch a user's ACTIVATED listings by owner, mirroring
// web-templates' GET /listings/owner/{ssoID}/status/ACTIVATED/?full=true. This is a
// different service than spaces-v2 (which has no owner-collection endpoint). The deploy
// environment must provide LISTINGS_ADDR/LISTINGS_PORT for the profile listings to load.
export const LISTINGS_HOST = process.env.LISTINGS_ADDR || "localhost";
export const LISTINGS_PORT = process.env.LISTINGS_PORT || "8129";
export const LISTINGS_API_ORIGIN = `http://${LISTINGS_HOST}:${LISTINGS_PORT}`;

// Search service
export const SEARCH_ADDR = process.env.SEARCH_ADDR || "localhost";
export const SEARCH_PORT = process.env.SEARCH_PORT || "3001";
export const SEARCH_API_ORIGIN = `http://${SEARCH_ADDR}:${SEARCH_PORT}`;

// Landing-pages service
// Serves the home page's popular keywords and the set of live landing-page permalinks.
export const LANDING_PAGES_HOST = process.env.LANDING_PAGES_HOST || "localhost";
export const LANDING_PAGES_PORT = process.env.LANDING_PAGES_PORT || "3007";
export const LANDING_PAGES_API_ORIGIN = `http://${LANDING_PAGES_HOST}:${LANDING_PAGES_PORT}`;

// Contentful (Strapi-backed) content service
// Serves the home page's CMS copy. Authenticated with HANDSHAKE_INTERNAL, not HANDSHAKE_ENV.
export const CONTENTFUL_HOST = process.env.CONTENTFUL_HOST || "localhost";
export const CONTENTFUL_PORT = process.env.CONTENTFUL_PORT || "8186";
export const CONTENTFUL_API_ORIGIN = `http://${CONTENTFUL_HOST}:${CONTENTFUL_PORT}`;

// Profiles service
export const PROFILES_ADDR = process.env.PROFILES_ADDR || "localhost";
export const PROFILES_PORT = process.env.PROFILES_PORT || "8125";
export const PROFILES_API_ORIGIN = `http://${PROFILES_ADDR}:${PROFILES_PORT}`;

// Projects service
export const PROJECTS_ADDR = process.env.PROJECTS_ADDR || "localhost";
export const PROJECTS_PORT = process.env.PROJECTS_PORT || "8145";
export const PROJECTS_API_ORIGIN = `http://${PROJECTS_ADDR}:${PROJECTS_PORT}`;

export const PROJECTS_STORE_HOST =
  process.env.PROJECTS_STORE_HOST || "localhost";
export const PROJECTS_STORE_PORT = process.env.PROJECTS_STORE_PORT || "8146";
export const PROJECTS_STORE_API_ORIGIN = `http://${PROJECTS_STORE_HOST}:${PROJECTS_STORE_PORT}`;

// Messaging service
export const MESSAGING_HOST = process.env.MESSAGING_HOST || "";
export const MESSAGING_PORT = process.env.MESSAGING_PORT || "9602";
export const MESSAGING_API_ORIGIN = `http://${MESSAGING_HOST}:${MESSAGING_PORT}`;

// External address
export const EXTERNAL_ADDRESS =
  process.env.EXTERNAL_ADDRESS || "http://dev.peerspaceapp.com";

// Facebook
export const FACEBOOK_APP_ID =
  process.env.FACEBOOK_APP_ID || "1608633012733574";

// Google
export const GOOGLE_SITE_ID =
  process.env.GOOGLE_SITE_ID || "3ULXPi0u9orsMFh2dMN1hHOX-rV34I0N7kN14s1jFVw";
export const GOOGLE_MAPS_SIGNING_KEY =
  process.env.GOOGLE_MAPS_SIGNING_KEY || "";
export const GOOGLE_MAPS_BROWSER_KEY =
  process.env.GOOGLE_MAPS_BROWSER_KEY || "";
export const GOOGLE_SIGNIIN_AUDIENCE_WWW =
  process.env.GOOGLE_SIGNIIN_AUDIENCE_WWW || "";

// Segment
export const SEGMENT_IO_API_KEY = process.env.SEGMENT_IO_API_KEY || "";
export const SEGMENT_CUSTOM_DOMAIN =
  process.env.SEGMENT_CUSTOM_DOMAIN || "beta-e.peerspaceapp.com";

// OneTrust (cookie consent CMP)
// Domain script UUID from the OneTrust admin console. The `-test` suffix selects the
// uncached pre-prod script, which is what non-production environments should stay on:
// production copy and geolocation rules are published separately from the test script.
export const ONETRUST_DOMAIN_SCRIPT_ID =
  process.env.ONETRUST_DOMAIN_SCRIPT_ID ||
  "01a03be6-9227-7800-9569-6a82e0a66a56-test";

// Twitter
export const TWITTER_APP_ID = process.env.TWITTER_APP_ID || "823879288";

// Pinterest
export const PINTEREST_APP_ID =
  process.env.PINTEREST_APP_ID || "5ddea59889c397d72c89cbc43a92dea7";

// Forter
export const FORTER_SNIPPET_KEY = process.env.FORTER_SNIPPET_KEY || "";

// Statsig
export const STATSIG_SDK_SERVER_KEY = process.env.STATSIG_SDK_SERVER_KEY || "";
export const STATSIG_SDK_CLIENT_KEY =
  process.env.STATSIG_SDK_KEY ||
  "client-MI9UJ1EGqbff6t1PmR0kpAyidq4AyEL7haCn2PlWZXO";

// Intercom
export const INTERCOM_APP_ID = process.env.INTERCOM_APP_ID || "ioz1lfrt";

// Branch SDK
export const BRANCH_SDK_KEY = process.env.BRANCH_SDK_KEY || "";

// Datadog RUM
export const DATADOG_RUM_APPLICATION_ID =
  process.env.DATADOG_RUM_APPLICATION_ID;
export const DATADOG_RUM_CLIENT_TOKEN = process.env.DATADOG_RUM_CLIENT_TOKEN;

export const PS_ENV = process.env.PS_ENV || "development";

export const RELEASE_TAG = process.env.RELEASE_TAG || "";
